<template>
  <el-dialog class="demand_model_dialog" top="5vh" center :title="newTitle" width="80%" :before-close="handleClose"
             :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
      <Share v-if="isUpdata" :shareInfo="{ pid: form.id, type: 'demand', tabid: tabid }" />
      <el-form-item label="需求标题" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off" :disabled="isProjectDisabled">
        </el-input>
      </el-form-item>
      <div style="display:flex;">
        <el-form-item label="项目体系" prop="systemId" :label-width="formLabelWidth">
          <el-select size="mini" :disabled="isProjectDisabled" @change="changeProjectSystem" v-model="form.systemId"
                     collapse-tags filterable placeholder="请选择项目体系">
            <el-option v-for="(key, value) in allSystem.ALLSYSTEMIDS" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称" prop="projectId" :label-width="formLabelWidth">
          <el-select size="mini" :disabled="isProjectDisabled"  v-model="form.projectId"
                     collapse-tags filterable placeholder="请选择项目体系">
            <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="需求人员" prop="demanderId" :label-width="formLabelWidth">
          <el-select size="mini" autocomplete="off" :disabled="isProjectDisabled" v-model="form.demanderId" collapse-tags filterable placeholder="请选择需求人员">
            <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="产品人员" prop="pmId" :label-width="formLabelWidth">
          <el-select size="mini" autocomplete="off" :disabled="isProjectDisabled" v-model="form.pmId" filterable
                     placeholder="请选择产品人员">
            <el-option v-for="(key, value) in allUserList.ALLUSERTYPE2" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="期望上线日期" prop="expectFinishDate" :label-width="formLabelWidth">
          <el-date-picker :disabled="isProjectDisabled"  value-format="yyyy-MM-dd"
                          v-model="form.expectFinishDate" type="date" placeholder="请选择日期" />
        </el-form-item>
        <el-form-item label="优先级" prop="priority" :label-width="formLabelWidth">
          <el-select size="mini" :disabled="isProjectDisabled" v-model="form.priority" filterable placeholder="请选择日期">
            <el-option v-for="(key, value) in allSelect.TEXTPRIORITY" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="技术负责人" prop="reviewerId" :label-width="formLabelWidth">
          <el-select size="mini" autocomplete="off"  :disabled="isProjectDisabled" v-model="form.reviewerId" clearable filterable collapse-tags
                     placeholder="请选择技术负责人">
            <el-option v-for="(item, index) in reviewerSelect" :key="index" :label="item" :value="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="isShowCompleteTime" label="计划上线日期" prop="planFinishDate" :label-width="formLabelWidth">
          <el-date-picker  :style="{ width: recordList.length > 0 ? '80%' : ''}" :disabled="isProjectDisabled"  value-format="yyyy-MM-dd"
                           v-model="form.planFinishDate" type="date" placeholder="请选择时间" />
          <el-popover v-if="recordList.length > 0" placement="bottom" height="30vh" width="900" trigger="click">
            <el-table :cell-style="getRowClass" max-height="400" v-loading="loading.record" :data="recordList">
              <el-table-column fixed width="60" property="demand_id" label="编号" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column property="preDate" label="调整前日期" width="100" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column property="planFinishDate" label="调整后日期" width="100" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column property="update_date_reason" min-width="100" label="调整原因" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column property="operatorUserName" label="操作人" width="80" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column property="operatorDateTime" label="操作时间" width="160" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
            <span slot="reference" style="cursor: pointer;color: #409EFF;font-size: 12px;">调整记录</span>
          </el-popover>
        </el-form-item>
        <el-form-item label="标签" prop="tag" :label-width="formLabelWidth">
          <el-input v-model="form.tag" autocomplete="off" :disabled="isProjectDisabled" placeholder="请输入">
          </el-input>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="需求类型" prop="type" :label-width="formLabelWidth">
          <el-select size="mini" autocomplete="off"  :disabled="isProjectDisabled" v-model="form.type" clearable filterable collapse-tags
                     placeholder="请选择">
            <el-option v-for="(item, index) in workOrderConfig.DEMANDTYPE" :key="index" :label="item" :value="index">
            </el-option>
          </el-select>
          <el-button style="margin-left:10px;" type="primary" @click="onAllocationDemand()" :disabled="isProjectDisabled">关联需求</el-button>
          <span v-if="addData.id">【{{addData.id}}】{{addData.demandName}}</span>
        </el-form-item>
        <el-form-item label="OA申请单号" prop="orderNumber" :label-width="formLabelWidth">
          <el-input v-model="form.orderNumber" autocomplete="off" :disabled="isProjectDisabled" placeholder="请输入OA申请单号" style="width:350px">
          </el-input>
        </el-form-item>
      </div>
      <div v-if="isUpdata" style="display: flex;">
        <el-form-item label="需求状态" prop="statusDesc" :label-width="formLabelWidth">
          {{ form.statusDesc }}
        </el-form-item>
        <el-form-item label="进度" prop="progressRate" :label-width="formLabelWidth">
          {{ form.progressRa ? '0%' : form.progressRate + '%'}}
        </el-form-item>
        <el-form-item label="创建日期" prop="createTime" :label-width="formLabelWidth">{{ form.createTime }}
        </el-form-item>
       
      </div>
      <div v-if="isUpdata" style="display: flex;">
        <el-form-item  label="PRD是否一次评审通过" prop="onePassReview" label-width="170px" style="margin-left: 38px;">
          <el-radio v-model="form.onePassReview" :disabled="isProjectDisabled" label="1">是</el-radio>
          <el-radio v-model="form.onePassReview" :disabled="isProjectDisabled" label="0">否</el-radio>
        </el-form-item>
        <el-form-item  label="是否需要统计用户使用情况" prop="userUse" label-width="170px" style="margin-left: 100px;">
          <el-radio v-model="form.userUse" :disabled="isProjectDisabled" label="1">是</el-radio>
          <el-radio v-model="form.userUse" :disabled="isProjectDisabled" label="0">否</el-radio>
        </el-form-item>
      </div>
      <el-form-item label="PRD链接" :label-width="formLabelWidth" prop="prdLink" :class="[isUpdata && (isSubmitDemand  || isSubmitReviewer) ? 'prdLink' : '']">
        <el-input ref="p_link" :disabled="isProjectDisabled" v-show="step === 2"  @input="focusLinkFn('prdLink')"
                  v-model="form.prdLink" clearable style="width: 60%"  placeholder="请以http://或https://开头" />
        <div @click="linkFn(form.prdLink)" v-show="step === 1 && form.prdLink"
             style="text-decoration: underline;color: #409EFF;cursor: pointer;display: inline-block;">
          {{ form.prdLink }}</div>
      </el-form-item>
      <el-form-item label="需求描述" prop="demandDesc" :label-width="formLabelWidth">
        <Editor v-if="!loading.dialog" :disabled="!isProjectDisabled" :content="form.demandDesc" @contentData="changeContent"
                :dialogVisibleModelType="form.id ? 'update' : 'create'" />
      </el-form-item>
      <div v-if="isUpdata">
        <el-form-item v-if="meetList.length > 0" :label-width="formLabelWidth">
          <div class="meet-line"><label>会议记录</label></div>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-button v-if="isAddMeet" size="mini" @click="onAddMeet('addmeet')"  type="warning">添加会议记录</el-button>
        </el-form-item>
        <el-form-item v-if="meetList.length > 0" :label-width="formLabelWidth">
          <MeetList  :demandId="form.id" :meetList="meetList" @change="change"/>
        </el-form-item>
      </div>
      <el-form-item v-if="showReviewedForm && (form.techDocLink || isReviewer)" prop="linkTo" label="技术文档链接" :label-width="formLabelWidth">
        <el-input ref="linkTo" :disabled="!isPStatus ? true : !isReviewerEdit"
                  v-if="isReviewerEdit" @input="focusLinkFn('linkTo')" v-model="form.techDocLink" clearable
                  style="width: 60%" placeholder="请以http://或https://开头" @change="changTechDocLink"></el-input>
        <div @click="linkFn(form.link_to)" v-else
             style="text-decoration: underline;color: #409EFF;cursor: pointer;display: inline-block;">
          {{ form.techDocLink }}</div>
      </el-form-item>
      <el-form-item v-if="showReviewedForm && (form.techDesc || isReviewer)" label="技术描述" prop="re_details" :label-width="formLabelWidth">
        <el-input type="textarea" :rows="6" :placeholder="'前端：\n1.\n后端：\n1.\n测试：\n1.'" :disabled="!isPStatus ? true : !isReviewerEdit"  v-model="form.techDesc"  @change="changTechDesc"/>
      </el-form-item>
      <el-form-item label="创建任务" :label-width="formLabelWidth" v-if="isPStatus &&  showTaskAdd||form.status===15">
        <el-button size="mini"  type="primary" @click="createImportTask()" :disabled="!isReviewerNew">批量导入任务</el-button>
      </el-form-item>
      <el-form-item label="任务" v-if="isPStatus &&  showTaskAdd||form.status===15" :label-width="formLabelWidth">
        <el-button size="mini" @click="onAddTask('add')"  type="primary" :disabled="!isReviewerNew">
          添加任务</el-button>
      </el-form-item>
      <el-form-item label="" v-if="showTaskList" :label-width="formLabelWidth">
        <el-table :data="tasks" border style="width: 100%; margin-top: -10px;"  height="40vh" stripe :cell-style="getRowClass" :header-cell-style="getCellClass">
          <el-table-column sortable fixed prop="taskId" align="center" label="任务ID" width="90">
          </el-table-column>
          <el-table-column prop="taskName" align="center" label="任务" min-width="120" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="table_text_click_new"
                    @click="linkToModel(scope.row, 'task',1)">{{ scope.row.taskName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="module" align="center" label="系统" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ allSelect.TEXTMODULES[scope.row.module] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="developsName" align="center" label="开发" width="80" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.developer.nameZh }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" align="center" label="任务状态" width="80" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="table_text_no_click">{{  scope.row.statusDesc }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="processRate" align="center" label="任务进度" width="80" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="planFinishTime" align="center" label="计划完成时间" width="120" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="160" v-if="isPStatus">
            <template slot-scope="scope">
              <!--              <el-button  @click="linkToModel(scope.row, 'task',1)" type="primary" size="small">详情
                            </el-button>-->
              <el-button :disabled="!((scope.row.status === 0 || scope.row.status === 1) && isReviewerNew)"  :loading="loading['task' + scope.row.taskId]" @click="onDeleteTask(scope.row)" type="danger" size="small">删除
              </el-button>
              <el-button :disabled="!isReviewerNew" @click="onAddTask('copy', scope.row)" type="warning" size="small">复制
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="测试任务" v-if="isPStatus &&  showTaskAdd||form.status===15" :label-width="formLabelWidth">
        <el-button size="mini" @click="onAddTestTask('add')"  type="primary" :disabled="!isReviewerNew">
          添加测试任务</el-button>
      </el-form-item>
      <el-form-item label=""  v-if="isUpdata &&  testTasks.length > 0" :label-width="formLabelWidth">
        <el-table :data="testTasks" border style="width: 100%; margin-top: -10px;"  height="40vh" stripe :cell-style="getRowClass" :header-cell-style="getCellClass">
          <el-table-column prop="id" sortable fixed label="任务ID" width="90">
          </el-table-column>
          <el-table-column prop="taskName" label="测试任务" min-width="180">
            <template slot-scope="scope">
              <span class="table_text_click_new" @click="onAddTestTask('add',scope.row)">{{ scope.row.taskName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="tester" label="测试人员">
            <template slot-scope="scope">
              <span>
             {{scope.row.tester.nameZh}}
            </span>
            </template>
          </el-table-column>
          <el-table-column prop="bugTotal" label="BUG">
            <template slot-scope="scope">
              <span>
             {{scope.row.bugHandlingcount}}/{{scope.row.bugTotal}}
            </span>
            </template>
          </el-table-column>
          <el-table-column prop="test_status_desc" label="状态">
          </el-table-column>
          <el-table-column prop="processRate" label="进度">
          </el-table-column>
          <el-table-column prop="planFinishTime" align="center" label="计划完成时间" width="120" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="160">
            <template slot-scope="scope">
              <!--              <el-button  @click="onAddTestTask('add',scope.row)" type="primary" size="small">详情
                            </el-button>-->
              <el-button :disabled="!((scope.row.test_status === 0) && isReviewerNew)"  :loading="loading['test' + scope.row.id]" @click="onDeleteTestTask(scope.row)" type="danger" size="small">删除
              </el-button>
              <el-button :disabled="!isReviewerNew" @click="onAddTestTask('copy', scope.row)" type="warning" size="small">复制
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item v-if="form.id && historylist.length" label="任务历史" :label-width="formLabelWidth">
        <TaskHistory :list="historylist" />
      </el-form-item>
      <el-form-item class="comment_warp" v-if="isUpdata" label="评论" :label-width="formLabelWidth">
        <Comment  :id="form.id" :busiId="form.id"  type="2"/>
      </el-form-item>
      <el-form-item class="note_warp" label="备注" prop="note" :label-width="formLabelWidth"  style="width: 100%; display: flex; flex-direction: column;">
        <div @click="click_note">
            <el-input type="textarea" v-model="form.note"  :autosize="{ minRows: 2 }"  style="width: 100%;"></el-input>
        </div>
        <div style="margin-top:10px;" v-show="show_create_note">
        <el-button type="primary" size="mini" @click="onNoteSubmit()">修 改</el-button>
        <el-button size="mini" @click="onNoteCancel()">取 消</el-button>
      </div>

<!--          <Comment  :id="form.id" :busiId="form.id"  type="2"/>-->
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-show="isUpdata && step === 1 && (isCreateUser || isPm) && isEditDemand" type="warning" @click="changeStep(2)">编 辑</el-button>
      <el-button v-show="!isUpdata || (isUpdata && step === 2 && (isCreateUser || isPm))" type="warning" :loading="loading.submit" @click="onSubmit">确 定</el-button>
      <el-button v-if="isUpdata &&  isPm && isSubmitReviewer && step === 1" type="warning" :loading="loading.submitReviewed" @click="onSubmitDemand(2)">提交技术评审</el-button>
      <el-button v-if="isUpdata &&  isReviewerNew && isRollback && step === 1" type="warning" :loading="loading.submitRollBack" @click="onRollback">回退</el-button>
      <el-button v-if="isUpdata && isConfirmReviewer && isReviewerNew && step === 1" type="warning" :loading="loading.submitConfirmReviewer"  @click="onSubmitConfirmReviewer()">确认评审</el-button>
      <el-button v-if="isUpdata && isSubmitDemand && isPm && step === 1" type="warning" :loading="loading.submitDemand" @click="onSubmitDemand(1)">提交需求评审</el-button>
      <el-button v-if="(isUpdata &&  isPm && !isChangetatus && step === 1)||isReviewerNew" type="warning" @click="dialogVisiblePStatus = true">变更状态</el-button>
      <el-button v-if="isUpdata &&  isPm  && step === 1 && (form.status === 8 || form.status === 9)" type="warning" @click="dialogVisibleUpdatePlanTime = true">调整上线日期</el-button>
      <el-button v-if="isUpdata &&  isPm && form.status === 13 && step === 1" type="warning" :loading="loading.submitReset" @click="queryChangePStatus(true)">重新启动</el-button>
      <el-button v-if="isPm && form.status === 8 && step === 1" type="primary"  @click="dialogVisiblePUat = true">完成UAT</el-button>
      <el-button v-if="isPm && form.status === 9 && step === 1" type="primary"  @click="onApplyRelease()">发布申请</el-button>
      <el-button v-if="isPm && form.status === 9 && step === 1" type="primary" @click="dialogVisibleSkip = true">跳过发布</el-button>
      <el-button v-if="isPm && form.status === 10 && step === 1" type="primary" :loading="loading.submitCancel" @click="onSubmitDemand(6)">取消发布申请</el-button>
      <el-button v-if="isPm && form.status === 11 && step === 1" type="primary" @click="dialogVisiblePro = true">完成上线</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
    <Task v-if="dialogVisibleTask" :dialogVisible='dialogVisibleTask' :hideDialogVisible="handleTaskClose" :formInfo="formTaskInfo" />
    <TestTask v-if="dialogVisibleTestTask" :dialogVisible='dialogVisibleTestTask' :hideDialogVisible="handleTestTaskClose" :formInfo="formTestTaskInfo"/>
    <AddMeet v-if="dialogVisibleMeet" :demandId="form.id"  :stage="getStage" :dialogVisible='dialogVisibleMeet' :hideDialogVisible="handleMeetClose"/>
    <el-dialog center :append-to-body="true" :title="newTitle" :visible.sync="dialogVisiblePStatus" width="40%">
      <el-form :model="pStatusForm" :rules="pStatusRules" ref="pStatusForm" >
        <el-form-item label="修改需求状态" prop="status" :label-width="formLabelWidth" >
          <el-select v-model="pStatusForm.status" placeholder="请选择" >
            <el-option label="暂停" value="13"></el-option>
            <el-option label="取消" value="14"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="原因" prop="changeReason" :label-width="formLabelWidth" >
          <el-input type="textarea" rows="3" v-model="pStatusForm.changeReason" autocomplete="off" placeholder="需求状态变更原因" />
        </el-form-item>
        <el-form-item label=""  :label-width="formLabelWidth" >
          <el-button size="small" type="primary" @click="onChangePStatus">确 定</el-button>
          <el-button size="small" @click="dialogVisiblePStatus = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog center :append-to-body="true" :title="newTitle" :visible.sync="dialogVisiblePUat" width="60%">
      <el-form :model="pUatForm" :rules="pUatRules" ref="pUatForm" >
        <el-form-item label="UAT验证结果" prop="uatStatus" :label-width="formLabelWidth">
          <el-select v-model="pUatForm.uatStatus">
            <el-option v-for="(key, val) in UATSTATUS" :key="key" :label="key" :value="val" />
            <!--            <el-option v-for="(key, val) in allSelect.TEXTTESTSTATUS" :key="key" :label="key" :value="val" />-->
          </el-select>
        </el-form-item>
        <el-form-item label="UAT验证描述" prop="uatDetail" :label-width="formLabelWidth">
          <Editor :disabled="true" :content="pUatForm.uatDetail" @contentData="changeUatContent"
                  dialogVisibleModelType="create" />
        </el-form-item>
        <el-form-item label=""  :label-width="formLabelWidth" >
          <el-button size="small" type="primary" :loading="loading.submitUat" @click="onChangePUat">确 定</el-button>
          <el-button size="small" @click="dialogVisiblePUat = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog center :append-to-body="true" :title="newTitle" :visible.sync="dialogVisiblePro" width="60%">
      <el-form :model="proForm" :rules="proRules" ref="proForm" >
        <el-form-item label="线上验证结果" prop="proStatus" :label-width="formLabelWidth">
          <el-select v-model="proForm.proStatus">
            <el-option v-for="(key, val) in UATSTATUS" :key="key" :label="key" :value="val" />
            <!--            <el-option v-for="(key, val) in allSelect.TEXTTESTSTATUS" :key="key" :label="key" :value="val" />-->
          </el-select>
        </el-form-item>
        <el-form-item label="验证描述" prop="proDetail" :label-width="formLabelWidth">
          <Editor :disabled="true" :content="proForm.proDetail" @contentData="changeProContent"
                  dialogVisibleModelType="create" />
        </el-form-item>
        <el-form-item label=""  :label-width="formLabelWidth" >
          <el-button size="small" type="primary" :loading="loading.submitComplete" @click="onChangePro">确 定</el-button>
          <el-button size="small" @click="dialogVisiblePro = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--  跳过发布 -->
    <el-dialog center :append-to-body="true" title="跳过发布" :visible.sync="dialogVisibleSkip" width="60%">
      <el-form :model="pSkipForm" :rules="pSkipRules" ref="pSkipForm" >
        <el-form-item label="跳过原因" prop="skipReason" :label-width="formLabelWidth">
          <Editor :disabled="true" :content="pSkipForm.skipReason" @contentData="changeSkipContent"
                  dialogVisibleModelType="create" />
        </el-form-item>
        <el-form-item label=""  :label-width="formLabelWidth" >
          <el-button size="small" type="primary" :loading="loading.skipRelease" @click="onApplySkipRelease">确 定</el-button>
          <el-button size="small" @click="dialogVisibleSkip = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--  调整上线时间   -->
    <el-dialog center :append-to-body="true" title="调整计划上线日期" :visible.sync="dialogVisibleUpdatePlanTime" width="60%">
      <el-form :model="updateTimeForm" :rules="updateTimeRules" ref="updateTimeForm" >
        <el-form-item label="原计划上线日期"  :label-width="formLabelWidth">
          <div>{{this.form.planFinishDate}}</div>
        </el-form-item>
        <el-form-item label="调整后上线日期" prop="planFinishDate" :label-width="formLabelWidth">
          <el-date-picker   value-format="yyyy-MM-dd"
                            v-model="updateTimeForm.planFinishDate" type="date" placeholder="请选择时间" :picker-options="pickerOptions"/>
        </el-form-item>
        <el-form-item label="调整原因" prop="update_date_reason" :label-width="formLabelWidth">
          <el-input type="textarea"  :autosize="{ minRows: 6, maxRows: 16 }"
                    placeholder="请输入调整原因" v-model="updateTimeForm.update_date_reason">
          </el-input>
          <!--          <Editor :disabled="true" :content="updateTimeForm.update_date_reason" @contentData="changeUpdateDateReasonContent"
                            dialogVisibleModelType="create" />
                    -->
        </el-form-item>
        <el-form-item label=""  :label-width="formLabelWidth">
          <el-button size="small" type="primary" :loading="loading.updateTimeLoad" @click="onUpdateTime">确 定</el-button>
          <el-button size="small" @click="dialogVisibleUpdatePlanTime = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


    <!-- 申请发布页面  -->
    <ApplyRelease v-if="dialogVisibleApplyRelease" :dialogVisible='dialogVisibleApplyRelease' :hideDialogVisible="handleApplyReleaseClose" :formInfo="formInfo"></ApplyRelease>
    <CreateImport v-if="dialogVisibleImportTask" :dialogVisible='dialogVisibleImportTask' :hideDialogVisible="handleImportTaskClose" :formInfo="form"></CreateImport>
    <AllocationDemand  v-if="dialogVisibleAlloctionDemand" :dialogVisible='dialogVisibleAlloctionDemand' :hideDialogVisible="handleAllocationDemandClose" :getChooseDemand="getChooseDemand" :addData="addData" :formInfo="form" :demand_id="form.id"></AllocationDemand>

  </el-dialog>
</template>
<script>
import { Editor } from "@/components/index.js";
import Task from '@/views/tops/devOps/producerSpace/components/task.vue'
import Comment from '@/views/tops/devOps/producerSpace/components/project/comment.vue'
import Share from '@/views/tops/devOps/producerSpace/components/share.vue'
import { formatEnToUtf8 } from "@/views/tops/devOps/components/util.js"
import  MeetList from "@/views/tops/devOps/producerSpace/components/meeting/list.vue";
import AddMeet from "@/views/tops/devOps/producerSpace/components/meeting/addMeet.vue";
import TestTask from '@/views/tops/devOps/producerSpace/components/testTask.vue';
import {TaskHistory} from "@/views/tops/devOps/components/list";
import CreateImport from "@/views/tops/devOps/producerSpace/components/createImport.vue";
import AllocationDemand from "@/views/tops/devOps/workOrder/components/allocationDemand.vue";
import {
  getDevOpsSpaceProducerListApi,
  postDevOpsSpaceDeleteTaskApi,
  postDevOpsSpaceUserPmEditStatusApi,
  postDevOpsSpaceCreateDemandApi,
  getDevOpsSpaceFindOneDemandApi,
  postDevOpsSpaceEditDemandApi,
  getDevOpsSpaceFindProjectNameApi,
  postDevOpsSpaceSubmitDemandApi,
  getDevOpsSpaceMeetListApi,
  getDevOpsSpaceDemandTestTaskApi,
  getDevOpsSpaceHistoryTaskListApi,
  getDevOpsSpaceReportTaskListApi,
  getDevOpsSpaceSystemDetailApi,
  postDevOpsSpaceDeleteTestTaskApi,
  getDevOpsSpaceDemandSkipApi,
  postDevOpsSpaceUpdatePlanDateApi,
  postDevOpsSpaceCreateProjectInsertCommentApi,
  postDevOpsSpaceDeleteProjectCommentApi,
  postDevOpsSpaceUpdateProjectCommentApi, postDevOpsSpaceCreateNoteApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {getDevOpsSpaceAllUserListApi} from "@/server/tops/base";
import ApplyRelease  from "@/views/tops/devOps/producerSpace/components/applyRelease.vue";
import createImport from "@/views/tops/devOps/producerSpace/components/createImport.vue";
export default {
  components: {TaskHistory, Editor, Comment, Task, Share, MeetList, AddMeet, TestTask, ApplyRelease, CreateImport, AllocationDemand},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    isShowCompleteTime:{
      type: Boolean,
      default: true,
    },
    tabid: {
      type: String,
      default: '',
    },
    workId: {
      type: String,
      default: null,
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      show_create_note: false,
      initialNote: '',
      reviewerds:[],
      meetList:[],
      addData: [
      ],
      historylist: [],
      form: {
        orderNumber:'',
        note:'',
        onePassReview:'1',
        userUse:'0',
        priority: 'P1',
        reviewer: {},
        re_details:'',
        demandDesc: '',
        reviewerId: '',
        progressRate: '',
        name:'',
        pmId: '',
        type:'',
      },
      pStatusForm:{
        isRestart: false,
        isRollBack: false,
        status:'',
        changeReason:'',
        back_status:false,
        id:''
      },
      pUatForm:{
        uatStatus:'',
        uatDetail:'',
      },
      proForm:{
        proStatus:'',
        proDetail:'',
      },
      pSkipForm:{
        skipReason:'',
      },
      updateTimeForm:{
        planFinishDate:'',
        update_date_reason:'',
      },
      reviewerForm:{
        reviewer:'',
        loading:false
      },
      pStatusRules:{
        status:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
        changeReason:{
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      pUatRules:{
        uatStatus:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
        uatDetail:{
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      proRules:{
        proStatus:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
        proDetail:{
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      pSkipRules:{
        skipReason:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      updateTimeRules:{
        update_date_reason:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
        planFinishDate:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      rules: {
        onePassReview: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        userUse: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        name: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        projectId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        systemId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        demanderId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        pmId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        priority: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        expectFinishDate: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        demandDesc: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        reviewerId: {
          required: this.formInfo.id,
          message: "必填",
          trigger: "blur",
        },
        planFinishDate:{
          required: this.formInfo.id,
          message: "必填",
          trigger: "blur"
        },
        prdLink: {
          required: this.formInfo.id,
          message: "必填",
          trigger: "blur",
        },
        type: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '135px',
      chainingLink: true,
      chainingLinkTo: true,
      loading: {
        dialog: false,
        submit: false,
        submitReviewed: false,
        submitRollBack:false,
        submitConfirmReviewer: false,
        submitDemand: false,
        submitReset: false,
        submitUat: false,
        submitApply: false,
        submitCancel: false,
        submitComplete: false,
        skipRelease: false,
        updateTimeLoad: false,
      },
      tasks: [],
      testTasks: [],
      dialogVisibleTask: false,
      dialogVisibleTestTask: false,
      dialogVisiblePStatus:false,
      dialogVisiblePUat: false,
      dialogVisibleReviwer: false,
      dialogVisibleMeet: false,
      dialogVisiblePro: false,
      dialogVisibleSkip: false,
      dialogVisibleUpdatePlanTime: false,
      step: 1,
      formTaskInfo: {},
      formTestTaskInfo: {},
      reviewerSelect: [],
      showDetails: false,
      // 判断是否是产品
      isUserPm:false,
      projectList: [],
      dialogVisibleApplyRelease: false,
      UATSTATUS:['失败','成功'],
      userId:'',
      username: '',
      record: false,
      updateText:[],
      recordList:[],
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() <= Date.now() - 60 * 60 * 24 * 1000;
        }
      },
      dialogVisibleImportTask: false,
      dialogVisibleAlloctionDemand: false,
    };
  },
  async mounted() {
    const { id = '', status = '',  name = '', next = false,orderTitle='',orderDesc='',orderCreator='', orderType = '', project_system_id = '' } = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.form = { ...this.form, id, status, name}
    this.$set(this.form, 'username', username)
    this.username = username;
    if (this.isUpdata) {
      // await this.getProjectList();
      await this.getMeetList(id);
      this.chainingLink = false;
      this.chainingLinkTo = false;
      await this.init(id);
      await this.getHistoryList();
      if(!this.workId && !this.form.type){
        this.form.type = '0';
      }
    } else {
      if(this.$store.state.devOps.userInfo.userId){
        let defaulepmId = this.$store.state.devOps.userInfo.userId;
        this.form.pmId = defaulepmId.toString();
      }
      this.step = 2;
      this.$set(this.form, 'user_pm', username)
      if(!this.workId){
        this.form.type = '0';
      }
      if(orderTitle) this.form.name = orderTitle;
      if(orderDesc) this.form.demandDesc = orderDesc;
      if(orderCreator) this.form.demanderId = orderCreator.toString();
      if(orderType == 1) this.form.type = '0';
      if(project_system_id) this.form.systemId = project_system_id.toString();
    }

    if(this.$store.state.devOps.userInfo.userId){
      this.userId = this.$store.state.devOps.userInfo.userId;
    }

    //获取未开始，进行中的项目
    this.$nextTick(async () => {
      //await this.getProjectList();
    })
  },
  computed: {
    createImport() {
      return createImport
    },
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
          workOrderConfig: (state) => state.devOps.WORKORDERCONFIG,
        }
    ),
    newTitle() {
      if (this.isUpdata) {/*
        if (this.isUnderReview) return '技术评审-' + this.form.name;*/
        return '[' + this.form.id + ']需求-' + this.form.name;
      } else {
        return '创建需求'
      }
    },
    //获取阶段
    getStage(){
      //需求讨论
      if(this.form.status === 0 || this.form.status === 1){
        return '1';
      }
      //需求评审
      if(this.form.status === 2 || this.form.status === 3){
        return '2'
      }
      //技术评审
      if(this.form.status === 4 || this.form.status === 5) {
        return '3';
      }
    },
    // 判断需求状态
    isPStatus() {
      const { status } = this.form;
      if( status === 13 || status === 14) return false;
      return true
    },
    //
    isChangetatus() {
      return this.form.status === 13 || this.form.status === 14 || this.form.status === 9 || this.form.status === 10 || this.form.status === 11 || this.form.status === 12;
    },
    // 判断是否是技术负责人
    isReviewer() {
      if(this.isAdmin || this.isReviewerLeader) return true;
      return this.form.reviewer.nameEn === this.form.username;
    },
    // 判断当前体系内有无负责人
    isReviewerNew(){
      let userId =JSON.parse(localStorage.getItem('userInfo')).userId;
      if(this.isAdmin || this.isReviewerLeader||this.reviewerds.includes(userId.toString())||(userId.toString())===this.form.reviewerId){
        return true
      }else{
        return false
      }
    },
    //判断技术负责人可以编写
    isReviewerEdit(){
      if(this.isReviewer){
        return this.form.status === 4 || this.form.status === 5;
      }
      return false;
    },
    // 判断是否是创建人
    isCreateUser(){
      if(this.form.creator){
        return this.form.creator.nameEn === this.form.username;
      }
      return false;
    },
    // 判断是否是产品
    isPm(){
      if(this.isAdmin || this.isPmLeader) return true;
      if(this.form.pm){
        return this.form.pm.nameEn === this.form.username;
      }
      return false;
    },
    isAddMeet(){
      return (this.isPm && (this.form.status === 0 || this.form.status === 1 || this.form.status === 2 || this.form.status === 3)) || (this.isReviewer &&(this.form.status === 4 || this.form.status === 5));

    },
    isAdmin(){
      if(this.username){
        if(this.allUserList.ALLUSERTYPE13 && this.allUserList.ALLUSERTYPE13[this.username]) return true
      }
      return false;
    },
    isPmLeader(){
      if(this.userId && this.form.pm){
        const pmId = this.form.pm.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[pmId]){
          return this.allUserList.LEADERUSER[pmId] === this.userId;
        }
      }
      return false;
    },
    isReviewerLeader(){
      if(this.userId && this.form.reviewer){
        const reviewerId = this.form.reviewer.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[reviewerId]){
          return this.allUserList.LEADERUSER[reviewerId] === this.userId ;
        }
      }
      return false;
    },
    //提交技术评审
    isSubmitReviewer(){
      return this.form.status === 2 || this.form.status === 3;
    },
    //提交需求评审
    isSubmitDemand(){
      return this.form.status === 1 || this.form.status === 0;
    },
    //回退
    isRollback(){
      return this.form.status === 4;
    },
    //确认评审
    isConfirmReviewer(){
      return this.form.status === 4 || this.form.status === 5;
    },
    //是否可编辑
    isEditDemand(){
      return this.form.status === 0 || this.form.status === 1 || this.form.status === 2 || this.form.status === 3;
    },
    // 判断是否是新建
    isUpdata() {
      return this.form.id;
    },
    // 需求部分不可编辑
    isProjectDisabled() {
      if (this.isUpdata) { // 如果是更新页面
        if (this.step === 1) return true;
      }
      return false; // 默认可编辑
    },
    // 展示技术负责人部分的表单
    showReviewedForm() {
      return this.form.status != 0 && this.form.status != 1 && this.form.status != 2 && this.form.status != 3;
    },
    // 判断是否展示任务添加
    showTaskAdd() {
      const { status, username, reviewer } = this.form;
      if ( status !== 13 && status !== 1 && status > 3 && status < 8) {
        return true;
      }
      return false;
    },
    // 判断是否展示任务列表
    showTaskList() {
      return  this.tasks.length;
    },
  },
  methods: {
    onAllocationDemand(){
      this.dialogVisibleAlloctionDemand = true;
    },
    getChooseDemand(choose){
      this.addData = choose;
    },
    getProjectList(systemId){
      getDevOpsSpaceFindProjectNameApi({isEffective:true,systemId: systemId}).then(res=>{
        if(res.data){
          this.projectList = res.data;
        }
      })
    },
    async getMeetList(id){
      await getDevOpsSpaceMeetListApi({demandId: id}).then((res)=>{
        this.meetList = res.data;
      });
    },
    async change(){
      await this.getMeetList(this.form.id);

    },
    async getHistoryList(){
      await getDevOpsSpaceHistoryTaskListApi({type:2,busiId: this.form.id}).then((res)=>{
        this.historylist = res.data;
      });
    },
    // 变更需求状态
    onChangePStatus(){
      this.$refs["pStatusForm"].validate(async (valid) => {
        if (valid) {
          this.queryChangePStatus()
        }
      })
    },
    onChangePUat(){
      this.$refs["pUatForm"].validate(async (valid) => {
        if (valid) {
          this.onSubmitDemand(4);
          //console.log(33333333)
          //this.queryChangePStatus()
        }
      })
    },
    onChangePro(){
      this.$refs["proForm"].validate(async (valid) => {
        if (valid) {
          this.onSubmitDemand(7);
          //console.log(33333333)
          //this.queryChangePStatus()
        }
      })
    },
    async queryChangePStatus(isRestart = false){
      this.$set(this.loading, 'submitReset', true)
      if(this.pStatusForm.status == '13'){
        if(this.form.status < 6){
          this.$notify({
            message:  "开发阶段中/测试阶段中/UAT阶段中才允许暂停",
            type: "error",
          })
          return false;
        }
      }
      try {
        let params =  { ...this.pStatusForm, id:this.form.id, status:Number(this.pStatusForm.status), isRestart:isRestart}
        const ret = await postDevOpsSpaceUserPmEditStatusApi(params);
        if(ret.status === 'success'){
          this.dialogVisiblePStatus = false;
          this.$notify({
            message: ret.message || "变更成功",
            type: "success",
          })
          this.hideDialogVisible()
        }else{
          this.$notify({
            message: ret.message || "变更失败",
            type: "error",
          })
        }
        this.loading.submitReset = false;
      } catch (error) {
        this.$notify({
          message: error || "变更失败",
          type: "error",
        })
        this.loading.submitReset = false;
      }
    },
    // 回退
    onRollback(){
      this.$confirm('此操作将回退到上一步, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        type: 'warning'
      }).then(async () => {
        try {
          this.$set(this.loading, 'submitRollBack', true)
          const ret = await postDevOpsSpaceUserPmEditStatusApi({id:this.form.id,isRollBack: true})
          if (ret.status === 'success') {
            this.$notify({
              message: '回退成功',
              type: "success",
            })
            setTimeout(() => {
              this.handleClose()
            }, 500)
          } else {
            this.$notify({
              message: ret.message || "回退失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "网络错误",
            type: "error",
          })
        } finally {
          this.loading.submitRollBack = false;
        }
      })
    },
    changeProjectSystem(val) {

      let arr = {};
      getDevOpsSpaceAllUserListApi({userType: 5,project_system_id:val}).then((res)=>{
        res.data.forEach((item,index)=>{
          arr[item.id] = item.user_name;
        });
        this.reviewerSelect = arr;
      });


      this.getProjectList(val);

    },
     click_note() {
      this.initialNote = this.form.note;
      if (this.form.id &&(this.isPm || this.isReviewerNew)) {
         this.show_create_note = true;
       }

    },
    async onNoteSubmit() {
      var noteId = this.form.id
      await postDevOpsSpaceCreateNoteApi({ note:this.form.note,demandId:noteId})
       this.show_create_note = false;
      // await this.queryNoteInfo()
      // this[stype] = '';
      // setTimeout(() => {
      //   this['show_' + stype] = false;
      // })
      return;


    },

    async onNoteCancel() {
      this.form.note = this.initialNote;
      this.show_create_note = false;
      return;
    },
    changeStep(step) {
      this.step = step;
      this.changeProjectSystem(this.form.systemId);
    },
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:20px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "font-size: 12px;padding:6px 0;";
    },
    // 获取需求详情
    async init(id) {
      this.loading.dialog = true
      try {
        const ret = await getDevOpsSpaceFindOneDemandApi({id:id });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          ...info,
          demanderId: info.demanderId?info.demanderId.toString(): '',
          systemId: info.systemId?info.systemId.toString():'',
          pmId: info.pm.id?info.pm.id.toString():'',
          reviewerId: info.reviewer.id ? info.reviewer.id.toString() : '',
          creator: info.creator,
          type: info.demand_type?info.demand_type.toString():'0',
          onePassReview:info.onePassReview||'1',
          userUse:info.userUse||'0'
          
        };
        this.isUserPm =( this.form.username === info.user_pm);
        this.addData={id:info.relevance_id,demandName:info.relevance_title};
        //this.changeProjectSystem(info.systemId);
        this.reviewerSelect = this.allUserList.ALLUSERTYPE1;
        this.recordList = info.update_text;
        this.getProjectList(this.form.systemId);
        this.queryTaskList(id);
        this.queryTestTaskList(id);
        if (info.details) { this.showDetails = true }
        if(info.status === 0 || info.status === 1){
          this.rules.reviewerId = false;
          this.rules.prdLink = false;
          this.rules.planFinishDate = false;
        }
        const res = await getDevOpsSpaceSystemDetailApi({ id:info.systemId });
        if(res.data[0]||{}){
          this.reviewerds=res.data[0].reviewerds.split(',')  
          localStorage.setItem('reviewerds',res.data[0].reviewerds)
        }  
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading.dialog = false
      }
    },
    onApplyRelease(){
      this.dialogVisibleApplyRelease = true;
    },
    async onApplySkipRelease(){
      this.$refs["pSkipForm"].validate(async (valid) => {
        if (valid) {
          this.$confirm("此操作将跳过发布, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            try{
              this.$set(this.loading, 'skipRelease', true)
              const res = await getDevOpsSpaceDemandSkipApi({demandId:this.form.id,skipReason:this.pSkipForm.skipReason});
              if(res.status === 'success'){
                this.$notify({
                  message: '提交成功',
                  type: "success",
                })
                setTimeout(() => {
                  this.handleClose()

                }, 500)
                this.loading.skipRelease =false;
              }else{
                this.$notify({
                  message: res.message || "提交失败",
                  type: "error",
                })
                this.loading.skipRelease =false;
              }
            }catch (error) {
              this.$notify({
                message: error || "网络错误",
                type: "error",
              })
              this.loading.skipRelease =false;
            }finally {
              this.loading.skipRelease =false;
            }

          });
        }
      })
    },
    onUpdateTime(){
      this.$refs["updateTimeForm"].validate(async (valid) => {
        if (valid) {
          try {
            let currentTime = Date.parse(this.getDate());
            let planFinishDate = Date.parse(this.updateTimeForm.planFinishDate);
            if(currentTime > planFinishDate){
              this.$notify({
                message: "修改日期要大于等于当前日期",
                type: "error",
              })
              return false;
            }
            if(this.updateTimeForm.planFinishDate == this.form.planFinishDate){
              this.$notify({
                message: "修改日期不能和原日期一致",
                type: "error",
              })
              return false;
            }
            this.$set(this.loading, 'updateTimeLoad', true);
            const {
              id = '',
            } = this.form;
            const update_date_reason = { demand_id: id, planFinishDate:this.updateTimeForm.planFinishDate ,update_date_reason:this.updateTimeForm.update_date_reason,preDate:this.form.planFinishDate,operatorDateTime: this.getNowDate()};
            const param = { demand_id: id, planFinishDate:this.updateTimeForm.planFinishDate ,updateDateText:update_date_reason,preDate:this.form.planFinishDate,};
            const ret =  await postDevOpsSpaceUpdatePlanDateApi(param);
            if (ret.status === 'success') {
              this.dialogVisibleUpdatePlanTime = false;
              await this.init(id);
              this.$notify({
                message: ret.message || "成功",
                type: "success",
              })
            } else {
              this.$notify({
                message: ret.message || "失败",
                type: "error",
              })
            }
          } catch (error) {
            this.$notify({
              message: error || "网络错误",
              type: "error",
            })
          } finally {
            this.loading.updateTimeLoad = false;
          }
        }

      })
    },
    // 添加任务
    onAddTask(type, row) {
      const {status,techDesc,techDocLink,id,name,pmId,pm,prdLink} = this.form;
      if (type === 'add') {
        this.formTaskInfo = { status, techDesc,techDocLink: this.formatLink(techDocLink), id,name, pmId, pm, prdLink: this.formatLink(prdLink),taskInfo: { pid: id, name } }
      }
      if (type === 'copy') {
        this.formTaskInfo = { status, techDesc,techDocLink: this.formatLink(techDocLink), id,name, pmId, pm, prdLink: this.formatLink(prdLink),taskInfo: { pid: id, name } }
        this.formTaskInfo.openType = 'copy';
        this.formTaskInfo.taskId = row.taskId;
      }
      this.dialogVisibleTask = true;
    },
    // 添加测试任务
    onAddTestTask(type, row) {
      const {techDocLink,id,name,pmId,pm,prdLink} = this.form;
      if (type === 'add') {
        this.formTestTaskInfo = {
          ...this.form,
          prdLink: this.formatLink(prdLink),
          techDocLink: this.formatLink(techDocLink),
          taskInfo: {
            ...row,
            pid: id,
          }
        }
      }
      if (type === 'copy') {
        this.formTestTaskInfo = {
          ...this.form,
          prdLink: this.formatLink(prdLink),
          techDocLink: this.formatLink(techDocLink),
          taskInfo: {
            ...row,
            pid: id,
            openType: 'copy',
          }
        }
      }


      this.dialogVisibleTestTask = true;
    },
    // 添加会议记录
    onAddMeet(type, row) {
      this.dialogVisibleMeet = true;
    },
    // 链接判断
    formatLink(val){
      if(!val) return '';
      return val.startsWith('http') ? val :`http://${val}`
    },
    // 需求提交
    async onSubmit(close = true) {
      if(this.form.reviewerId){
        this.form.reviewerId = this.form.reviewerId.toString();
      }
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.moduleSubmit(close)
        }
      });
    },
    //确认评审
    async onSubmitConfirmReviewer(){
      if(this.tasks.length < 1){
        this.$notify({
          message: "请添加开发任务和测试任务!",
          type: "error",
        })
        return false;
      }
      const {
        name = "",
        projectId = "",
        systemId = '',
        demanderId = '',
        pmId = [],
        priority = "",
        planFinishDate = "",
        demandDesc = "",
        reviewerId = '',
        prdLink = '',
        expectFinishDate = '',
        techDocLink = '',
        techDesc = '',
        p_status = '',
        id = '',
        tag = '',
        note='',
        onePassReview='1',
        userUse='0'
      } = this.form;
      const param = {  note,onePassReview,userUse,name, demandDesc,projectId, id: id, demanderId:Number(demanderId) ,pmId: Number(pmId), systemId:Number(systemId), project_status: p_status, priority, reviewerId:Number(reviewerId),planFinishDate, expectFinishDate, prdLink: this.formatLink(prdLink), techDocLink: this.formatLink(techDocLink),techDesc:techDesc,tag};
      this.$set(this.loading, 'submitConfirmReviewer', true);
      this.onSubmitDemand(3)
    },
    //提交需求评审
    async onSubmitDemand(type){
      /* if(this.form.reviewerId){
         this.form.reviewerId = this.form.reviewerId.toString();
       }*//*
      this.rules.reviewerId = true;
      this.rules.prdLink = true;*/
      if(type === 1 || type === 2){
        if(!this.form.reviewerId){
          this.$notify({
            message: "技术负责人必填",
            type: "error",
          })
          return false;
        }
        if(!this.form.prdLink){
          this.$notify({
            message: "PRD必填",
            type: "error",
          })
          return false;
        }
      }
      let content = '此操作将进行到下一步, 是否继续?';
      if(type === 1){
        content = '请确认提交需求评审？';
      }
      if(type === 2){
        content = '请确认提交技术评审？';
      }
      if(!this.form.demandDesc){
        this.form.demandDesc = '1';
      }

      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.$confirm(content, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true,
            type: 'warning'
          }).then(async () => {
            this.form.reviewerId = this.form.reviewerId.toString();
            try {
              if(type === 2)  this.$set(this.loading, 'submitReviewed', true);
              if(type === 1)  this.$set(this.loading, 'submitDemand', true);
              if(type === 6)  this.$set(this.loading, 'submitCancel', true);
              if(type === 7)  this.$set(this.loading, 'submitComplete', true);
              if(type === 4)  this.$set(this.loading, 'submitUat', true);
              if(type === 3)  this.$set(this.loading, 'submitConfirmReviewer', true);


              let params =  {id: this.form.id,type:type,onePassReview:this.form.onePassReview,userUse:this.form.userUse};
              if(type === 2){
                await this.onSubmit();
              }
              if(type === 4){
                params = {...params,...this.pUatForm,}
              }
              if(type === 7){
                params = {...params,...this.proForm,}
              }            
              await postDevOpsSpaceSubmitDemandApi(params).then(async(result)=>{

                if(result.status === 'success'){
                  await this.moduleSubmit()
                  this.$notify({
                    message: result.message || '提交成功',
                    type: "success",
                  })
                  setTimeout(() => {
                    this.handleClose()
                  }, 500)
                }else{
                  this.$notify({
                    message: result.message || "提交失败",
                    type: "error",
                  })
                  this.handleClose()
                }

                this.loading.submitReviewed = false;
                this.loading.submitDemand = false;
                this.loading.submitCancel = false;
                this.loading.submitComplete = false;
                this.loading.submitUat = false;
                this.loading.submitConfirmReviewer = false;
              });
            } catch (error) {
              this.$notify({
                message: error || "网络错误",
                type: "error",
              })
            } finally {
              this.loading.submitReviewed = false;
              this.loading.submitDemand = false;
              this.loading.submitCancel = false;
              this.loading.submitComplete = false;
              this.loading.submitUat = false;
              this.loading.submitConfirmReviewer = false;
            }
          })
        }
      })
    },
    // 调用需求提交接口
    async moduleSubmit(close = true){
      try {
        close && this.$set(this.loading, 'submit', true)
        const {
          orderNumber='',
          name = "",
          projectId = "",
          systemId = '',
          demanderId = '',
          pmId = [],
          priority = "",
          planFinishDate = "",
          demandDesc = "",
          reviewerId = '',
          prdLink = '',
          expectFinishDate = '',
          p_category = [],
          techDocLink = '',
          techDesc = '',
          p_status = '',
          id = '',
          tag = '',
          type = '',
          note='',
          onePassReview='1',
           userUse='0'
        } = this.form;
        let work_demand_id = null;
        if(this.addData.id){
          work_demand_id = this.addData.id;
        }
        let workId = null;
        if(this.workId){
          workId= this.workId;
        }
        const param = { orderNumber,onePassReview, userUse,note,name, demandDesc,projectId, id: id, demanderId:Number(demanderId) ,pmId: Number(pmId), systemId:Number(systemId), project_status: p_status, priority, reviewerId:Number(reviewerId),planFinishDate, expectFinishDate, prdLink: this.formatLink(prdLink), techDocLink: this.formatLink(techDocLink),techDesc:techDesc,tag,type,work_id:workId,work_demand_id:work_demand_id};
        // id 存在 更新 不存在 创建
        const ret = this.isUpdata ? await postDevOpsSpaceEditDemandApi({ ...param, demand_id: this.form.id || "" }) : await postDevOpsSpaceCreateDemandApi(param);
        if (ret.status === 'success') {
          if (close) {
            this.$notify({
              message: '提交成功',
              type: "success",
            })
            setTimeout(() => {
              this.handleClose()

            }, 500)
          }
        } else {
          this.$notify({
            message: ret.message || "失败",
            type: "error",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || "网络错误",
          type: "error",
        })
      } finally {
        this.loading.submit = false;
      }
    },
    changTechDocLink(val){
      this.saveSubmit();
    },
    changTechDesc(){
      this.saveSubmit();
    },
    async saveSubmit(){
      const {
        name = "",
        projectId = "",
        systemId = '',
        demanderId = '',
        pmId = [],
        priority = "",
        planFinishDate = "",
        demandDesc = "",
        reviewerId = '',
        prdLink = '',
        expectFinishDate = '',
        techDocLink = '',
        techDesc = '',
        p_status = '',
        id = '',
        note='',
        onePassReview='1',
         userUse='0'
      } = this.form;
      const param = { note,onePassReview,userUse,name, demandDesc,projectId, id: id, demanderId:Number(demanderId) ,pmId: Number(pmId), systemId:Number(systemId), project_status: p_status, priority, reviewerId:Number(reviewerId),planFinishDate, expectFinishDate, prdLink: this.formatLink(prdLink), techDocLink: this.formatLink(techDocLink),techDesc:techDesc};
      await postDevOpsSpaceEditDemandApi({...param, demand_id: this.form.id || "" });
    },
    // 修复 input 框输入 乱聚焦到富文本的问题
    focusLinkFn(refName) {
      setTimeout(() => {
        this.$refs[refName].focus()
      })
    },
    // 跳转外链
    linkFn(url) {
      window.open(url)
    },
    // 打开新的模块
    linkToModel(row, type, back = '') {
      let newRow = {
        ...this.form,
        ...row,
      }
      /*if(type === 'task'){
        newRow.pid = this.form.id;
        newRow.id = row.taskId;
      }*/
      this.showDialogVisible(type, newRow, back)
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    // 修改富文本内容
    changeContent(val) {
      this.form.demandDesc = val;
    },
    // 修改富文本内容
    changeUatContent(val) {
      this.pUatForm.uatDetail = val;
    },
    changeProContent(val) {
      this.proForm.proDetail = val;
    },
    // 修改富文本内容
    changeSkipContent(val) {
      this.pSkipForm.skipReason = val;
    },
    changeUpdateDateReasonContent(val){
      this.updateTimeForm.update_date_reason = val;
    },
    // 删除任务
    onDeleteTask(row) {
      this.$confirm("此操作将删除该任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$set(this.loading, 'task' + row.taskId, true)
        try {
          const res = await postDevOpsSpaceDeleteTaskApi({
            id: row.taskId,
          });
          if (res.status === "success") {
            this.queryTaskList(this.form.id)
          } else {
            this.$notify({
              message: res?.data?.msg || "删除失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "数据错误",
            type: "error",
          })
        } finally {
          this.loading['task' + row.taskId] = false;
        }
      });
    },
    // 删除测试任务
    onDeleteTestTask(row) {
      this.$confirm("此操作将删除该测试任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$set(this.loading, 'test' + row.id, true)
        try {
          const res = await postDevOpsSpaceDeleteTestTaskApi({
            id: row.id,
          });
          if (res.status === "success") {
            this.queryTestTaskList(this.form.id)
          } else {
            this.$notify({
              message: res.message || "删除失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "数据错误",
            type: "error",
          })
        } finally {
          this.loading['test' + row.id] = false;
        }
      });
    },
    handleApplyReleaseClose(){
      this.dialogVisibleApplyRelease = false;
      this.init(this.form.id);
      this.queryTaskList(this.form.id)
      this.queryTestTaskList(this.form.id)
    },
    // 批量导入
    createImportTask(type, row) {
      this.dialogVisibleImportTask = true;
    },
    // 关闭任务弹窗
    handleTaskClose() {
      this.dialogVisibleTask = false;
      if(this.form.reviewer.nameEn === 'jonny_jiang'){
        window.localStorage.setItem('step1', '关闭页面Id:'+this.form.id);
      }
      this.init(this.form.id);
      if(this.form.reviewer.nameEn === 'jonny_jiang'){
        window.localStorage.setItem('step2', '页面init完成:'+this.form.id);
      }
      this.queryTaskList(this.form.id);
      if(this.form.reviewer.nameEn === 'jonny_jiang'){
        window.localStorage.setItem('step3', '开发任务初始化完成:'+this.form.id);
      }
      this.queryTestTaskList(this.form.id);
      if(this.form.reviewer.nameEn === 'jonny_jiang'){
        window.localStorage.setItem('step4', '测试任务初始化完成:'+this.form.id);
      }
      this.getHistoryList();
      if(this.form.reviewer.nameEn === 'jonny_jiang'){
        window.localStorage.setItem('step5', '历史任务初始化完成:'+this.form.id);
      }
      this.getMeetList(this.form.id);
      if(this.form.reviewer.nameEn === 'jonny_jiang'){
        window.localStorage.setItem('step6', '会议初始化完成:'+this.form.id);
      }
    },
    handleTestTaskClose(){
      this.dialogVisibleTestTask = false;
      this.init(this.form.id);
      this.queryTaskList(this.form.id)
      this.queryTestTaskList(this.form.id)
      this.getHistoryList();
      this.getMeetList(this.form.id);
    },
    handleImportTaskClose(){
      this.dialogVisibleImportTask = false;
      this.init(this.form.id);
      this.queryTaskList(this.form.id)
      this.queryTestTaskList(this.form.id)
      this.getHistoryList();
      this.getMeetList(this.form.id);
    },
    handleAllocationDemandClose(){
      this.dialogVisibleAlloctionDemand = false;
    },
    // 关闭任务弹窗
    handleMeetClose() {
      this.dialogVisibleMeet = false;
      this.getMeetList(this.form.id);
      this.init(this.form.id)
      this.queryTaskList(this.form.id)
      this.queryTestTaskList(this.form.id)
      this.getHistoryList();
    },
    // 任务列表
    async queryTaskList(id) {
      try {
        const res = await getDevOpsSpaceProducerListApi({ demandId: id });
        this.tasks = res.data || []
      } catch (error) {
        console.error(error)
      }
    },
    // 获取测试任务列表
    async queryTestTaskList(id) {
      try {
        const res = await getDevOpsSpaceDemandTestTaskApi({ demandId: id });
        this.testTasks = res.data || []
      } catch (error) {
        console.error(error)
      }
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      let h = today.getHours() < 10 ? '0'+today.getHours() : today.getHours();
      let m = today.getMinutes() < 10 ? '0'+today.getMinutes() : today.getMinutes();
      let s = today.getSeconds() < 10 ? '0'+today.getSeconds() : today.getSeconds();
      return year + "-" + cmonth + "-" + cday + " " + h + ":" + m + ":" + s;
    },
    getDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
  }
};
</script>
<style lang="scss">
.demand_model_dialog {
  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
}

.popperDom {
  max-width: 240px;
}
.meet-line{
  height: 1px;
  border-top: 1px solid #ddd;
  text-align: center;
  margin-top: 20px;
}
.meet-line label{
  position: relative;
  top: -8px;
  background: #fff;
  padding: 0 20px;
  font-weight: bold;
  color: #606266;
}
.prdLink label:before {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}
</style>
